import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const serviceAreas = [{
  name: "Mumbai, India",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/mumbai_hq.png",
  link: "/PropVRaiRedesignPage"
}, {
  name: "Dubai, UAE",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/dubai_studio.png",
  link: "/PropVRaiRedesignPage"
}, {
  name: "London, UK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/london_hub.png",
  link: "/PropVRaiRedesignPage"
}, {
  name: "New York, USA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/new_york_office.png",
  link: "/PropVRaiRedesignPage"
}, {
  name: "Singapore City",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/singapore_node.png",
  link: "/PropVRaiRedesignPage"
}];
export default function JurisdictionsCoverage() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section data-section-id="30731" id="regional-access-points" className="bg-background text-foreground">
      {}
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div ref={headerRef} className={`max-w-3xl transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl font-bold tracking-tight text-primary sm:text-5xl font-default mb-4">
            Regional Access Points
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Our global network ensures seamless spatial intelligence delivery across major real estate markets. Access our localized 3D visualization hubs spanning Asia, the Middle East, Europe, and the Americas.
          </p>
        </div>
      </div>

      {}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-0">
        {serviceAreas.map((area, i) => <div key={area.name} data-index={i} className="group relative aspect-square w-full overflow-hidden bg-muted rounded-none shadow-sm hover:shadow-xl transition-all duration-300">
            {}
            <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110" style={{
          backgroundImage: `url(${area.image})`
        }} />

            {}
            <div className="absolute inset-0 bg-white/70 backdrop-blur-[2px] transition-colors duration-300 group-hover:bg-white/50" />

            {}
            <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
              <h3 className="mb-4 text-xl font-bold uppercase tracking-tight text-foreground font-default">
                {area.name}
              </h3>

              {}
              <div className="translate-y-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                <Button asChild variant="outline" size="sm" className="border-primary text-primary bg-white hover:bg-primary hover:text-white font-semibold border-2">
                  <Link to={area.link}>
                    Get Directions
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}